<template>
  <v-dialog :model-value="modelValue" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="pt-4">Loads</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <v-select
          color="primary"
          label="Load type"
          :items="items"
          v-model="item"
          filled
        >
        </v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!item"
          @click="create()"
          color="primary"
          text
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script>
  import { mapActions, mapState } from "vuex"

  export default {
    name: "LoadsDialog",
    props: {
      modelValue: { required: true }
    },
    data: () => ({
      items: ["Uniform load", "Tree load"],
      item: null
    }),
    computed: {
      ...mapState("stabSchematisationStage", {
        currentItemStage: state => state.currentItem
      })
    },
    methods: {
      ...mapActions("uniformLoads", {
          addUniformLoad: "add"
        }
      ),
      ...mapActions("treeLoads", {
          addTreeLoad: "add"
        }
      ),
      close () {
        this.$emit("update:modelValue", false)
      },
      create () {
        this.item === "Uniform load" ? this.addUniformLoad({
          id: this.currentItemStage.id,
          field: "stab_schematisation_stage"
        }) : null
        this.item === "Tree load" ? this.addTreeLoad({
          id: this.currentItemStage.id,
          field: "stab_schematisation_stage"
        }) : null
        this.close()
      }
    }

  }
</script>
